// extracted by mini-css-extract-plugin
export default {"wrapper":"K96tU ZdH1P","title":"g3Kvc","emptyBlock":"CTBRs","button":"Ju9PO","cnButton":"aRbQA","banner":"PQYLN","bannerMobile":"Eu1MT"};